import {computed, observable, makeObservable} from "mobx";

import {BaseModel} from "../../infrastructure/models/base-model";

export class StandingsPreviewDisplayModel extends BaseModel {
  @observable competitionsIds: Array<Number>;
  @observable competitorId: Number;
  @observable sportIds: Array<Number>;

  constructor() {
    super();

    this.sportIds = null;
    this.competitionsIds = null;
    this.competitorId = null

    makeObservable(this);
  }

  @computed get hasEntityIds(): Boolean {
    const hasSports: Boolean = this.sportIds?.length > 0;
    const hasCompetitions: Boolean = this.competitionsIds?.length > 0;
    const hasCompetitor: Boolean = this.competitorId > 0;

    return hasCompetitions || hasCompetitor || hasSports;
  }
}
